import { useState } from "react";
import { IConversation } from "@pages/askDost/types";

export const useChatActionMenu = (
  requestRename: (e: React.MouseEvent, conv: any) => void,
  requestDelete: (e: React.MouseEvent, id: string) => void
) => {
  const [actionMenuAnchor, setActionMenuAnchor] = useState<{
    el: HTMLElement;
    conv: IConversation;
  } | null>(null);

  const openActionMenu = (e: React.MouseEvent<HTMLElement>, conv: IConversation) => {
    e.stopPropagation();
    setActionMenuAnchor({ el: e.currentTarget, conv });
  };

  const closeActionMenu = () => setActionMenuAnchor(null);

  const handleRenameClick = (e: React.MouseEvent) => {
    if (actionMenuAnchor) requestRename(e, actionMenuAnchor.conv);
    closeActionMenu();
  };

  const handleDeleteClick = (e: React.MouseEvent) => {
    if (actionMenuAnchor) requestDelete(e, actionMenuAnchor.conv.id);
    closeActionMenu();
  };

  return {
    actionMenuAnchor,
    openActionMenu,
    closeActionMenu,
    handleRenameClick,
    handleDeleteClick,
  };
};